import { render, staticRenderFns } from "./ColorPick.vue?vue&type=template&id=51d73b6a&scoped=true&"
import script from "./ColorPick.vue?vue&type=script&lang=js&"
export * from "./ColorPick.vue?vue&type=script&lang=js&"
import style0 from "./ColorPick.vue?vue&type=style&index=0&id=51d73b6a&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d73b6a",
  null
  
)

export default component.exports